var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomEmptyImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 142,
    viewBox: "0 0 224 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130.481 60.8912C130.481 88.0233 144.687 106.072 123.971 110.018C111.541 112.386 106.806 88.0233 106.806 60.8912C106.806 33.7591 120.375 11.7642 123.971 11.7642C127.566 11.7642 130.481 33.7591 130.481 60.8912Z",
    fill: "#9481CD",
    fillOpacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 137.837H18.0216M41.1054 137.837H68.3324M112.132 137.837H68.3324M68.3324 137.837L74.0041 111.794M152.973 137.837H138.176H224H152.973ZM152.973 137.837L142.122 93.4454M74.0041 111.794L142.122 93.4454M74.0041 111.794L80.578 81.6076M142.122 93.4454L135.755 67.4022M135.755 67.4022L80.578 81.6076M135.755 67.4022L129.679 42.5427M80.578 81.6076L86.6364 53.7886M86.6364 53.7886L97.3351 4.66162H120.419L129.679 42.5427M86.6364 53.7886L129.679 42.5427",
    stroke: "#A7388E",
    strokeWidth: 8.28649,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomEmptyImage);
export default __webpack_public_path__ + "static/media/CustomEmptyImage.a135eca7f0af43195b405c282a338cee.svg";
export { ForwardRef as ReactComponent };